export const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS';

export const addTranslations = translations => {
    return {
        type: ADD_TRANSLATIONS,
        payload: translations
    }
};



// WEBPACK FOOTER //
// ./src/actions/TranslationActions.js